import React from 'react';
import PropTypes from 'prop-types';

import { Button } from 'react-bootstrap5';
import IconWithText from 'components/Widgets/IconWithText';

export default function SelectedFilePreview({ file, removeFile, disabled }) {
  return (

    <div>
      {file && (
      <div className="d-flex">
        {file.name}
        <Button
          variant="link"
          onClick={removeFile}
          disabled={disabled}
        >
          <IconWithText
            iconClassName="trash-icon small-icon"
            wrapperClassName="ps-1"
          />
        </Button>
      </div>
      )}
    </div>
  );
}

SelectedFilePreview.propTypes = {
  file: PropTypes.object,
  removeFile: PropTypes.func,
  disabled: PropTypes.bool,
};

SelectedFilePreview.defaultProps = {
  file: null,
  disabled: false,
  removeFile: () => {},
};
